/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_FinishingInputs */

const vi_tea_machines_finishing = /** @type {(inputs: Tea_Machines_FinishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kết thúc…`)
};

/**

* @param {Tea_Machines_FinishingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_finishing = /** @type {((inputs?: Tea_Machines_FinishingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_FinishingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_finishing(inputs)
});